export type Params<Param extends string> = `:${Param}`;
export const getPath = <T extends string>(path: T) => path;

/**
 * Checks if an actual route matches a dummy/template route pattern.
 * Dynamic segments are identified by regex: UUIDs, numeric IDs, or '0' placeholders.
 *
 * @param dummyRoute - Template route using 0 for dynamic segments
 * @param actualRoute - The real route to match against
 * @returns boolean
 */

const DYNAMIC_SEGMENT = /^(0|[0-9]+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function matchesRoute(dummyRoute: string, actualRoute: string): boolean {
  const dummyParts = dummyRoute.split("/").filter(Boolean);
  const actualParts = actualRoute.split("/").filter(Boolean);

  if (dummyParts.length !== actualParts.length) return false;

  return dummyParts.every((part, i) => {
    if (DYNAMIC_SEGMENT.test(part)) return true;
    return part === actualParts[i];
  });
}
